import API from './base';

class TheoryAccessApi extends API {
  checkRemainingAccess = (schoolId) => this.get(`/api/web/v1/schools/${schoolId}/theory_access_selling_availability`);

  getPaymentData = (schoolId) => this.get(`/api/web/v1/schools/${schoolId}/theory_access_payments/new`);

  getAvailableCodes = () => this.get('/api/web/v1/student/theory_access_credentials');
}

export default new TheoryAccessApi();
